import { render, staticRenderFns } from "./PageBICompetitorPerformance.vue?vue&type=template&id=367ec862"
import script from "./PageBICompetitorPerformance.vue?vue&type=script&lang=js"
export * from "./PageBICompetitorPerformance.vue?vue&type=script&lang=js"
import style0 from "./PageBICompetitorPerformance.vue?vue&type=style&index=0&id=367ec862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports